import moment from "moment";

export const sortByCreatedDateTime = (
	data,
	dateKey = "createdDate",
	timeKey = "createdTime"
) => {
	if (!Array.isArray(data)) {
		console.warn(
			"sortByCreatedDateTime: Provided data is not an array.",
			data
		);
		return [];
	}

	return [...data].sort((a, b) => {
		const momentA = moment(a[dateKey]).set({
			hour: moment(a[timeKey], "HH:mm:ss").hour(),
			minute: moment(a[timeKey], "HH:mm:ss").minute(),
			second: moment(a[timeKey], "HH:mm:ss").second(),
		});

		const momentB = moment(b[dateKey]).set({
			hour: moment(b[timeKey], "HH:mm:ss").hour(),
			minute: moment(b[timeKey], "HH:mm:ss").minute(),
			second: moment(b[timeKey], "HH:mm:ss").second(),
		});

		// Descending (latest first)
		return momentB.valueOf() - momentA.valueOf();
	});
};
